import {BaseService} from './baseService.js';
import {Service} from './service.js';

/**
 * Handles file
 */
export class FileService extends BaseService {
	
	static get properties() {		
		return {			
		};
	}
	
	constructor() {	
		super();
	}
	
	async getFiles(path, options) {
		var params = '';
		if (options) {
			params =  this.toQueryParam(options);
		}		
		var data = await this.makeGETRequest('/api/resource/files?path=' + encodeURIComponent(path) + '&' + params);
		return data;
	}
	
	downloadFileObject(directory, filename, options) {
		var params = '';
		if (options) {
			params =  this.toQueryParam(options);
		}	
		this.downloadFile('/api/resource/files/download?directory=' + encodeURIComponent(directory) + '&fileName='+ encodeURIComponent(filename) + '&' + params);		
	};

	exportFiles(path, options) {
		var params = '';
		if (options) {
			params = this.toQueryParam(options);
		}
		this.downloadFile('/api/resource/files/export?path=' + encodeURIComponent(path || '/') + '&' + params);
	}
	
	async deleteFile(directory, filename) {	
		var results = await this.makeDELETERequest('/api/resource/files/remove?directory=' + encodeURIComponent(directory) + '&fileName='+ encodeURIComponent(filename));
		return results;
	}
	
}
